import Papa from 'papaparse'

export default function csvToJSON(csv) {
  const { data } = Papa.parse(csv)
  const headings = data[0]
  const res = []

  for (let i = 1; i < data.length; i += 1) {
    const row = data[i]
    let hasContent = false

    const rowObj = headings.reduce((o, heading, headingIndx) => {
      const content = row[headingIndx] || ''
      o[heading] = content
      hasContent = hasContent || content.length > 0
      return o
    }, {})

    if (hasContent) res.push(rowObj)
  }

  return res
}
